import { TOAST_TIMEOUT } from 'src/config/Toast';
import store from 'src/store';
import { createToast } from 'src/store/toastsSlice';
import apiClient from 'src/utils/apiClient';
import { FormDataRow, RegionForm } from 'src/store/adminConfigPageSlice/regionTasksPageSlice/types';
import { MeasureUnit, RegionTask, Task, TaskGroup, TaskGroupPayload } from './types';
// import DummyAPIClient from 'src/utils/__helpers__/DummyAPIClient';

// **** Functions **** //

/**
 * Fetch units of measure
 */
async function fetchMeasureUnits(): Promise<MeasureUnit[]> {
  const { data } = await apiClient.get('/measureUnits');
  return data;
}

/**
 * Fetch regions
 */
async function fetchRegions(): Promise<RegionForm[]> {
  const { data } = await apiClient.get('/regions');
  return data;
}

/**
 * Fetch all tasks
 */
async function fetchTasks(): Promise<Task[]> {
  const { data } = await apiClient.get('/tasks');
  return data;
}

/**
 * Create or update task (create if id not provided)
 */
async function createOrUpdateTask(data: Task): Promise<Task> {
  const res = await apiClient.post('/tasks', data);
  if (res) {
    store.dispatch(
      createToast({
        type: 'success',
        message: data.id ? 'Updated task successfully' : 'Created task successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
  }
  return res.data;
}

/**
 * Get RegionTasks by regionId.
 */
async function fetchRegionTasksByRegionId(regionId: number): Promise<RegionTask[]> {
  const { data } = await apiClient.get(`/regionTasks/${regionId}`);
  return data;
}

/**
 * Update a list of RegionTasks
 */
async function updateRegionTasks(data: RegionTask[]): Promise<RegionTask[]> {
  const res = await apiClient.post('/regionTasks', data);
  if (res) {
    store.dispatch(
      createToast({
        type: 'success',
        message: 'Updated region tasks successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
  }
  return res.data;
}

/**
 * Update RestrictionForm tasks
 */
async function updateRestrictionForm(data: FormDataRow): Promise<FormDataRow> {
  // Do API call
  const res = await apiClient.post('/regions', {
    id: data.id,
    name: data.name,
    restrictionFormName: data.formName,
    restrictionFormActive: data.isActive,
    restrictionFormDescription: data.description,
  });
  // Toast when finished
  if (res) {
    store.dispatch(
      createToast({
        type: 'success',
        message: 'Updated restriction form successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
  }
  // Return
  return res.data;
}

/**
 * Fetch all tasks
 */
async function fetchTaskGroups(): Promise<TaskGroup[]> {
  const { data } = await apiClient.get('/taskGroups');
  // const { data } = await DummyAPIClient.get<TaskGroup>('/taskGroups');
  return data;
}

/**
 * Create or update task (create if id not provided)
 */
async function addOrUpdateTaskGroup(data: TaskGroupPayload): Promise<TaskGroup | null> {
  const res = await apiClient.post('/taskGroups', data);
  // const res = await DummyAPIClient.post('/taskGroups', data);
  if (!!res && res.data) {
    store.dispatch(
      createToast({
        type: 'success',
        message: `${data.id ? 'Updated' : 'Created'} task group successfully`,
        timeout: TOAST_TIMEOUT,
      }),
    );
    return res.data as TaskGroup;
  }
  return null;
}

// **** Export **** //

export default {
  fetchTasks,
  fetchMeasureUnits,
  fetchRegions,
  createOrUpdateTask,
  fetchRegionTasksByRegionId,
  updateRegionTasks,
  updateRestrictionForm,
  fetchTaskGroups,
  addOrUpdateTaskGroup,
} as const;
